import { Box, Card, CardContent } from "@mui/material";
import type { StatisticsReport } from "../../lib/types";
import { formatCurrency, formatDate } from "./formatters";
import { EmptyStatisticsCard, MerchantRanking } from "./StatisticsRankings";

export type GroupedExpense = { merchant: string; categoryId: string | null | undefined; categoryName: string; currency: string; total: number; count: number; lastDate: string };

export function StatisticsPayees({ report, currency, expenses, onMerchant, onCategory }: { report: StatisticsReport; currency: string; expenses: GroupedExpense[]; onMerchant: (merchant: string) => void; onCategory: (categoryId: string | null | undefined) => void }) {
  return (
    <Box className="stat-grid">
      <MerchantRanking items={report.merchants_by_amount} currency={currency} onDrill={onMerchant} />
      <Card className="records-panel stat-card"><CardContent className="records-panel-content">
        <div className="stat-card-heading"><h2>Top expenses</h2><span>Largest spending, repeats grouped</span></div>
        <div className="stat-expense-list">
          {expenses.map((expense) => <button type="button" key={`${expense.merchant}|${expense.categoryId || ""}`} onClick={() => expense.merchant === "No payee" ? onCategory(expense.categoryId) : onMerchant(expense.merchant)} title="Show in Records"><span><strong>{expense.merchant}</strong><small>{expense.count > 1 ? `${expense.count} payments` : formatDate(expense.lastDate)} · {expense.categoryName}</small></span><b>{formatCurrency(expense.total, expense.currency)}</b></button>)}
          {!expenses.length ? <EmptyStatisticsCard message="No expenses in this period." /> : null}
        </div>
      </CardContent></Card>
    </Box>
  );
}
